// extracted by mini-css-extract-plugin
export var hasSubmenu = "mobile-menu-module--has-submenu--f9e6b";
export var menuItem = "mobile-menu-module--menu-item--c1836";
export var opened = "mobile-menu-module--opened--c8511";
export var phoneButton = "mobile-menu-module--phone-button--2e59d";
export var subMenu = "mobile-menu-module--sub-menu--87fc9";
export var trialButton = "mobile-menu-module--trial-button--838c5";